(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Rotating-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-banner-slideshow')) {
    class CustomBannerSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.custom-banner-slide'));
        this.track = this.querySelector('.custom-banner-slideshow__track');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
        this.toggleButton = this.querySelector('[data-autoplay-toggle]');
        this.status = this.querySelector('.custom-banner-slideshow__status');
        this.viewport = this.querySelector('.custom-banner-slideshow__viewport');
        this.currentIndex = 0;
        this.timer = null;
        this.userPaused = false;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.touchStartX = 0;
        this.enabled = this.dataset.enabled === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.swipeEnabled = this.dataset.swipe === 'true';
        this.delay = Number(this.dataset.delay) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.update(false);

        if (!this.enabled || this.slides.length < 2) {
          return;
        }

        this.previousButton?.addEventListener('click', () => {
          this.showPrevious(true);
        }, { signal });

        this.nextButton?.addEventListener('click', () => {
          this.showNext(true);
        }, { signal });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(Number(dot.dataset.slideDot), true);
          }, { signal });
        });

        this.toggleButton?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updateToggle();
          this.syncAutoplay();
        }, { signal });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showPrevious(true);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showNext(true);
          }
        }, { signal });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => {
            this.hoverPaused = true;
            this.syncAutoplay();
          }, { signal });

          this.addEventListener('mouseleave', () => {
            this.hoverPaused = false;
            this.syncAutoplay();
          }, { signal });
        }

        this.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.syncAutoplay();
        }, { signal });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.focusPaused = false;
            this.syncAutoplay();
          }
        }, { signal });

        if (this.swipeEnabled) {
          this.viewport?.addEventListener('touchstart', (event) => {
            this.touchStartX = event.changedTouches[0].clientX;
          }, { passive: true, signal });

          this.viewport?.addEventListener('touchend', (event) => {
            const distance = event.changedTouches[0].clientX - this.touchStartX;

            if (Math.abs(distance) < 45) {
              return;
            }

            if (distance > 0) {
              this.showPrevious(true);
            } else {
              this.showNext(true);
            }
          }, { passive: true, signal });
        }

        document.addEventListener('visibilitychange', () => {
          this.syncAutoplay();
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.custom-banner-slide');

          if (!slide || !this.contains(slide)) {
            return;
          }

          this.userPaused = true;
          this.goTo(Number(slide.dataset.slideIndex), false);
          this.updateToggle();
          this.syncAutoplay();
        }, { signal });

        this.syncAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.abortController?.abort();
      }

      goTo(index, userInitiated) {
        const lastIndex = this.slides.length - 1;
        let nextIndex = index;

        if (this.loop) {
          nextIndex = (index + this.slides.length) % this.slides.length;
        } else {
          nextIndex = Math.max(0, Math.min(index, lastIndex));
        }

        if (nextIndex === this.currentIndex) {
          if (userInitiated) {
            this.restartAutoplay();
          }
          return;
        }

        this.currentIndex = nextIndex;
        this.update(true);

        if (userInitiated) {
          this.restartAutoplay();
        }
      }

      showPrevious(userInitiated) {
        this.goTo(this.currentIndex - 1, userInitiated);
      }

      showNext(userInitiated) {
        const lastIndex = this.slides.length - 1;

        if (!this.loop && this.currentIndex === lastIndex) {
          this.stopAutoplay();
          return;
        }

        this.goTo(this.currentIndex + 1, userInitiated);
      }

      update() {
        this.slides.forEach((slide, index) => {
          const active = index === this.currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });

        if (this.classList.contains('custom-banner-slideshow--slide')) {
          this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;
        }

        this.dots.forEach((dot, index) => {
          const active = index === this.currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });

        if (this.previousButton) {
          this.previousButton.disabled = !this.loop && this.currentIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled = !this.loop && this.currentIndex === this.slides.length - 1;
        }

        if (this.status) {
          this.status.textContent = `Slide ${this.currentIndex + 1} of ${this.slides.length}`;
        }
      }

      updateToggle() {
        if (!this.toggleButton) {
          return;
        }

        const paused = this.userPaused;
        this.toggleButton.dataset.state = paused ? 'paused' : 'playing';
        this.toggleButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      }

      startAutoplay() {
        if (!this.autoplay || this.reducedMotion || this.timer) {
          return;
        }

        this.timer = window.setInterval(() => {
          this.showNext(false);
        }, this.delay);
      }

      stopAutoplay() {
        if (!this.timer) {
          return;
        }

        window.clearInterval(this.timer);
        this.timer = null;
      }

      syncAutoplay() {
        const shouldPause =
          !this.autoplay ||
          this.userPaused ||
          this.hoverPaused ||
          this.focusPaused ||
          document.hidden ||
          this.reducedMotion;

        if (shouldPause) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.syncAutoplay();
      }
    }

    customElements.define('custom-banner-slideshow', CustomBannerSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
